<template>
  <div id="app">
    <component :is="layout" :class="layout">
      <router-view></router-view>
    </component>
  </div>
</template>
<script>
import gql from "@/graphql/apollo"
import { mapActions } from "vuex";

window.commonData = {
  isPublice: false,
};
Window.todoBoolean = true;
export default {
  watch:{
    getIdToken:{
      deep:true,
      immediate:true,
      handler(oldV){
        if (oldV){
          apolloProvider.clients.builtin.query({
            client: 'builtin',
            fetchPolicy: "network-only",
            query: gql.getPosts,
            variables: {
              first: 1,
              offset: 0
            }
          }).catch(error => {
            try {
              if (JSON.stringify(error).indexOf('OIDC_BC_LOGOUT') !== -1){
                this.signOutOidc();
              }
            }catch (e) {
              console.log(e);
            }
          })
        }
      }
    }
  },
  methods:{
    ...mapActions('oidcStore',["signOutOidc"])
  },
  computed: {
    getIdToken(){
      return this.$store.state.oidcStore.id_token
    },
    getMobile() {
      var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag === null) {
        return false;
      } else {
        return true;
      }
    },
    layout() {
      let meta = this.getMobile;
      let layout = meta ? "mobile" : "pc";
      return layout;
    },
  },
};
</script>

<style lang="less">
@import '~@/assets/todoCenter/default/css/taskcenter.less';
@import '~@/assets/todoCenter/default/css/wechat.less';
</style>



// WEBPACK FOOTER //
// src/App.vue